module.exports = __webpack_public_path__ + "img/binding_mb_tab_02.d8be912a.png";